import React from "react";
import {
  ImgBlendingcoffee,
  ImgCL,
  ImgComercialDiaz,
  ImgConforma,
  ImgFrutasbosquemar,
  ImgImperiodeleones,
  ImgInfocontrol,
  ImgMedisan,
  ImgMetalfort,
  ImgProinspecta,
  ImgQuintabogados,
  ImgRodotour,
  ImgStartCode,
  ImgTectronix,
  ImgTransporteMJ,
  ImgVidrioalum,
} from "../../images/clientes";

const ModernClients = () => {
  const clients = [
    { name: "CL", logo: ImgCL },
    { name: "StartCode", logo: ImgStartCode },
    { name: "Proinspecta", logo: ImgProinspecta },
    { name: "Infocontrol", logo: ImgInfocontrol },
    { name: "Medisan", logo: ImgMedisan },
    { name: "Conforma", logo: ImgConforma },
    { name: "Comercial Díaz", logo: ImgComercialDiaz },
    { name: "Tectronix", logo: ImgTectronix },
    { name: "Metalfort", logo: ImgMetalfort },
    { name: "Vidrio Alum", logo: ImgVidrioalum },
    { name: "Quinta Bogados", logo: ImgQuintabogados },
    { name: "Blending Coffee", logo: ImgBlendingcoffee },
    { name: "Imperio de Leones", logo: ImgImperiodeleones },
    { name: "Rodotour", logo: ImgRodotour },
    { name: "Frutas Bosquemar", logo: ImgFrutasbosquemar },
    { name: "Transporte MJ", logo: ImgTransporteMJ },
  ];

  return (
    <section className="section-modern clients-modern">
      <div className="auto-container">
        <div className="section-header-modern">
          <div className="section-header-modern-subtitle">
            Nuestros Clientes
          </div>
          <h2 className="section-header-modern-title">
            Empresas que confían en nosotros
          </h2>
          <p className="section-header-modern-description">
            Hemos trabajado con empresas de diversos sectores, desde startups
            hasta grandes corporaciones, brindando soluciones contables y
            tributarias de calidad.
          </p>
        </div>

        <div className="clients-modern-grid">
          {clients.map((client, index) => (
            <div
              key={index}
              className="client-logo-modern animate-fade-in-up"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <img src={client.logo} alt={client.name} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ModernClients;
